<template>
  <div class="DataRoomLayout" data-locator="dataroom-settings">
    <h1 class="pb-4 ml-1">
      {{ $t("project.project-settings.layouts.DataRoomLayout.dataRoomSettings") }}
    </h1>
    <ProjectSettingsMainSettings :mnemo="roomMnemo"/>
    <ProjectSettingsAccessRights id="accessRightsContainer" class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsDataroomFeatures class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsDataRoomInfo :mnemo="roomMnemo" :show-upgrade-dialog="showUpgradeDialog" class="mt-8" />
    <ProjectSettingsNotifications class="mt-8" :mnemo="roomMnemo"/>
  </div>
</template>

<script>
  import { useGoTo } from 'vuetify'
  import { mapGetters } from 'vuex'
  
  import ProjectSettingsAccessRights from '@/project/project-settings/access-rights/AccessRights.vue'
  import ProjectSettingsNotifications from '@/project/project-settings/notifications/ProjectSettingsNotifications.vue'
  import ProjectSettingsDataRoomInfo from '@/project/project-settings/ProjectSettingsDataRoomInfo.vue'
  import ProjectSettingsMainSettings from '@/project/project-settings/ProjectSettingsMainSettings.vue'

  import ProjectSettingsDataroomFeatures from '../ProjectSettingsDataroomFeatures.vue'

  export default {
    name: 'DataRoomLayout',
    components: {
      ProjectSettingsAccessRights,
      ProjectSettingsNotifications,
      ProjectSettingsDataroomFeatures,
      ProjectSettingsDataRoomInfo,
      ProjectSettingsMainSettings,
    },
    data () {
      return {
        showUpgradeDialog: false,
      }
    },
    computed: {
      ...mapGetters('room', ['roomMnemo']),
    },
    mounted () {
      if (this.$route.query?.show === 'upgradeDialog') {
        this.showUpgradeDialog = true
      }
      const goTo = useGoTo()
      if (window.history.state.goTo) {
        goTo(
          window.history.state.goTo,
          { offset: 50 },
        )
      }
    },
  }
</script>
